import {
  Body,
  BTCValue,
  Cell,
  CellTitle,
  CellValue,
  Footer,
  LocalValue,
  Row,
  Title,
} from "./styles";
import { Copy } from "../../../../../components/Copy";
import { FormButton } from "../../../../../components/Form";
import {
  formatCurrency,
  getCashflowDetail,
  getCashflowListSZT,
  statusConvert,
  statusSZTConvert,
  typeConvertNew,
  typeConvertSZT,
} from "../../../../../services/app";
import { decimalAdjust } from "../../../../../utils/Currency";
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { useApp } from "../../../../../contexts";
import ModalCancel from "../cancel";
import { EqualIcon } from "../../../../wallet-list/styles";
import Modal from "../../../../../components/Modal/Modal";
import {
  DesktopContainer,
  MobileContainer,
} from "../../../../../components/Container";
import ModalWithdraw from "../../../../withdraw/modal";
import styled from "styled-components";
import { useSearchParams } from "react-router-dom";
function Detail(props) {
  const {
    T,
    formatLocalCurrency,
    getCurrency,
    convertToLocalCurrency,
    convertToCurrency,
    setLoading,
    currencies,
    setAlert,
    isMobile,
  } = useApp();
  const [searchParams, setSearchParams] = useSearchParams();
  const id = props.id;
  const code = props.code;
  const onClose = props.onClose;
  const type = props.type;
  const contentRef = useRef();
  const positionScrollRef = useRef(0);
  const [row, setRow] = useState();

  const [mode, setMode] = useState("detail");
  useEffect(() => {
    const modeParam = searchParams.get("mode");
    if (modeParam) {
      setMode(modeParam);
    }
  }, [searchParams]);

  const ModalContainer = styled(Modal.Container)`
    padding: 52px 59px 55px 70px;
    background: #f5f5f5;
    box-shadow: 0px 0px 36px rgba(0, 0, 0, 0.25);
    border-radius: 64px;
    width: 850px;
    @media (max-width: 1024px) {
      box-shadow: 0px 16px 36px rgba(104, 109, 132, 0.4157);
      border-radius: 32px;
      padding: 42px 27px 43px 28px;
    }
  `;

  const ContentWaper = styled.div`
    max-height: 80vh;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  `;

  useEffect(() => {
    loadData().then();
  }, [id]);

  const getNameByCode = (code) => {
    return currencies.find((item) => item.code === code)?.name || "";
  };

  const convertData = () => {
    const item = row;
    let status = code === "SZT" ? statusSZTConvert(item) : statusConvert(item);
    let itemType = code === "SZT" ? typeConvertSZT(item) : typeConvertNew(item);
    const convertCode =
      item?.transaction_type === 1 ||
      item?.transaction_type === 7 ||
      item?.transaction_type === 5 ||
      item?.transaction_type === 6
        ? item?.dest_currency_code
        : item?.from_currency_code;
    return item
      ? {
          ...item,
          local: convertToLocalCurrency(
            item.amount,
            convertCode,
            getCurrency()
          ),
          id: item.id,
          transactionId: item.id,
          type: itemType,
          typeCode: item.type,
          coin: item.dest_currency_code,
          coinFrom: item.from_currency_code,
          amount: item.amount,
          toAmount:
            code !== "SZT"
              ? decimalAdjust(
                  "floor",
                  parseFloat(item.final_amount) * parseFloat(item.current_rate),
                  -8
                )
              : convertToCurrency(
                  item.amount,
                  item.from_currency_code,
                  item.dest_currency_code,
                  getCurrency()
                ),
          amoutConvert: decimalAdjust(
            "floor",
            parseFloat(item.amount) * parseFloat(item.current_rate),
            -8
          ),
          feeConvert: decimalAdjust(
            "floor",
            parseFloat(item.fee_amount) * parseFloat(item.current_rate),
            -8
          ),
          fee_amount: code !== "SZT" ? item.fee_amount : item.fee,
          coinValue: formatCurrency(item.final_amount, null, getCurrency()),
          status: status,
          statusCode: item.status,
          time: moment(item.created_time).format("YYYY/MM/DD HH:mm:ss"),
        }
      : {};
  };

  const loadData = async () => {
    setLoading(true);
    let result = null;
    if (code === "SZT") {
      const resultList = await getCashflowListSZT({
        transactionId: id,
      });
      if (resultList.data?.data?.cashflows?.count > 0) {
        const transData = resultList.data?.data?.cashflows.rows[0] || {};
        result = {
          status: 200,
          data: {
            data: {
              transaction: {
                ...transData,
                local: convertToLocalCurrency(
                  transData.amount,
                  "SZT",
                  getCurrency()
                ),
                id: transData.id,
                transactionId: transData.transactionId,
                transactionCode: transData.transactionCode,
                from_currency_code: "SZT",
                dest_currency_code: "ETH",
                typeCode: transData.type,
                coin: "ETH",
                code: transData.transactionCode,
                coinFrom: "SZT",
                amount: Math.abs(transData.amount || 0),
                toAmount: Math.abs(transData.amount || 0),
                fee: Math.abs(transData.fee || 0),
                statusCode: transData.status,
                created_time: transData.createTime,
              },
            },
          },
        };
      } else {
        result = {
          status: 400,
          data: {
            error: {
              message: "Some error happened. Please try again later.",
            },
          },
        };
      }
    } else {
      result = await getCashflowDetail(id);
    }
    setLoading(false);
    if (result.status === 200) {
      const item =
        {
          ...result?.data?.data?.transaction,
          type: code !== "SZT" ? result?.data?.data?.cashflow.type : undefined,
          transaction_type: result?.data?.data?.transaction.type,
        } || {};
      setRow(item);
    } else {
      setAlert({
        type: "error",
        text: result?.data?.error?.message || "",
      });
      onClose();
    }
    setLoading(false);
  };

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = positionScrollRef.current;
    }
  });

  const value = convertData() || {};

  if (mode === "confirm") {
    return (
      <ModalWithdraw
        onClose={(value) => {
          setSearchParams(
            (prev) => {
              const params = new URLSearchParams(prev);
              params.set("mode", "detail");
              return params;
            },
            {
              replace: true,
            }
          );
          if (value) {
            setAlert({
              type: value,
              text:
                value === "success"
                  ? T("Withdrawal request has been created")
                  : T("Failed to create a withdrawal request"),
            });
            if (value === "success") {
              onClose();
            }
          }
        }}
        value={value}
      />
    );
  }

  return (
    <Modal>
      <Modal.ModalBg onClose={onClose} />
      <ModalContainer onClose={onClose} ref={contentRef}>
        <ContentWaper
          onScroll={(e) => {
            positionScrollRef.current = e.target?.scrollTop;
          }}
          ref={contentRef}
          id="content-detail"
        >
          {mode === "detail" ? (
            <>
              <Title>{T("Transaction details")}</Title>
              {row ? (
                <>
                  <Body className={value.statusCode === 4 && "reject"}>
                    <Row className="lg:w-[266px]">
                      {type === "crypto" ? (
                        <>
                          <Cell>
                            <CellTitle>{T("Transaction Hash")}</CellTitle>
                            <CellValue>
                              {value?.tx_id ? (
                                <Copy
                                  splitFont={16}
                                  cutText={true}
                                  text={value?.tx_id}
                                />
                              ) : null}
                            </CellValue>
                          </Cell>
                          <MobileContainer>
                            <Cell>
                              <CellTitle>{T("Transaction ID")}</CellTitle>
                              <CellValue className="transactionId">
                                <Copy text={value?.code} />
                              </CellValue>
                            </Cell>
                          </MobileContainer>
                        </>
                      ) : (
                        <>
                          <Cell>
                            <CellTitle>{T("Transaction Hash")}</CellTitle>
                            <CellValue>
                              {value?.tx_id ? (
                                <Copy
                                  splitFont={16}
                                  cutText={true}
                                  text={value?.tx_id}
                                />
                              ) : null}
                            </CellValue>
                          </Cell>
                          <Cell>
                            <CellTitle>{T("Transaction ID")}</CellTitle>
                            <CellValue className="transactionId">
                              <Copy
                                splitFont={25}
                                splitEnd={0}
                                numDot={3}
                                text={value?.code}
                              />
                            </CellValue>
                          </Cell>
                          <MobileContainer>
                            <Cell>
                              <CellTitle>{T("Time")}</CellTitle>
                              <CellValue>{value.time}</CellValue>
                            </Cell>
                          </MobileContainer>
                        </>
                      )}
                      {type === "crypto" && (
                        <Cell>
                          <CellTitle>{T("Time")}</CellTitle>
                          <CellValue>{value.time}</CellValue>
                        </Cell>
                      )}

                      {type === "crypto" ? (
                        <>
                          <Cell>
                            <CellTitle>{T("Type")}</CellTitle>
                            <CellValue className="capitalize">
                              {T(value.type)}
                            </CellValue>
                          </Cell>
                          <MobileContainer>
                            <>
                              <Cell>
                                <CellTitle>{T("From Address")}</CellTitle>
                                {value?.from_wallet_address ? (
                                  <CellValue>
                                    <Copy
                                      splitFontLg={32}
                                      splitFont={25}
                                      splitEnd={0}
                                      numDot={3}
                                      text={value?.from_wallet_address}
                                    />
                                  </CellValue>
                                ) : null}
                              </Cell>
                              <Cell>
                                <CellTitle>{T("To Address")}</CellTitle>
                                <CellValue>
                                  {value?.dest_wallet_address ? (
                                    <Copy
                                      splitFontLg={32}
                                      splitFont={25}
                                      splitEnd={0}
                                      numDot={3}
                                      text={value?.dest_wallet_address}
                                    />
                                  ) : null}
                                </CellValue>
                              </Cell>
                            </>
                          </MobileContainer>
                          <Cell>
                            <CellTitle>{T("Coin")}</CellTitle>
                            {value.from_currency_code ? (
                              <CellValue>
                                {value?.dest_currency_code ||
                                value.from_currency_code
                                  ? `${getNameByCode(
                                      value.dest_currency_code ||
                                        value.from_currency_code
                                    )} (${
                                      value.dest_currency_code ||
                                      value.from_currency_code
                                    })`
                                  : ""}
                              </CellValue>
                            ) : null}
                          </Cell>

                          <MobileContainer>
                            <Cell>
                              <CellTitle>
                                {value.dest_currency_code} {T("Value")}
                              </CellTitle>
                              {type == "crypto" && value.typeCode == 5 ? (
                                <CellValue>
                                  <BTCValue>
                                    {value?.toAmount} {"ETH"}
                                  </BTCValue>
                                  <LocalValue>
                                    <div className="mr-1">
                                      <EqualIcon style={{ width: "12px" }} />
                                    </div>{" "}
                                    {formatLocalCurrency(value.local)}
                                  </LocalValue>
                                </CellValue>
                              ) : (
                                <CellValue>
                                  <BTCValue>
                                    {value?.coinValue}{" "}
                                    {value.dest_currency_code ||
                                      value.from_currency_code}
                                  </BTCValue>
                                  <LocalValue>
                                    <div className="mr-1">
                                      <EqualIcon style={{ width: "12px" }} />
                                    </div>{" "}
                                    {formatLocalCurrency(value.local)}
                                  </LocalValue>
                                </CellValue>
                              )}
                            </Cell>
                          </MobileContainer>

                          {value?.typeCode === 2 ? (
                            <Cell>
                              <CellTitle>{T("Request Amount")}</CellTitle>
                              <CellValue>
                                {formatCurrency(
                                  value.amount,
                                  null,
                                  getCurrency()
                                )}{" "}
                                {value.dest_currency_code ||
                                  value.from_currency_code}
                              </CellValue>
                            </Cell>
                          ) : (
                            <Cell>
                              <CellTitle>{T("Amount")}</CellTitle>
                              {value.typeCode == 5 && type === "crypto" ? (
                                <CellValue>
                                  {formatCurrency(
                                    value.amoutConvert,
                                    null,
                                    getCurrency()
                                  )}{" "}
                                  {value.dest_currency_code}
                                </CellValue>
                              ) : (
                                <CellValue>
                                  {formatCurrency(
                                    value.amount,
                                    null,
                                    getCurrency()
                                  )}{" "}
                                  {value.dest_currency_code ||
                                    value.from_currency_code}
                                </CellValue>
                              )}
                            </Cell>
                          )}
                          <Cell
                            style={{ borderBottom: isMobile ? "" : "none" }}
                          >
                            <CellTitle>{T("Fee")}</CellTitle>
                            {value.typeCode == 5 && type === "crypto" ? (
                              <CellValue>
                                {formatCurrency(
                                  value.feeConvert,
                                  null,
                                  getCurrency()
                                )}{" "}
                                {value.dest_currency_code}
                              </CellValue>
                            ) : (
                              <CellValue>
                                {formatCurrency(
                                  value.fee_amount,
                                  null,
                                  getCurrency()
                                )}{" "}
                                {value.dest_currency_code ||
                                  value.from_currency_code}
                              </CellValue>
                            )}
                          </Cell>
                        </>
                      ) : (
                        <>
                          {value?.from_currency_code
                            ?.toString()
                            ?.toLowerCase() === "sotd" ? (
                            <>
                              <Cell>
                                <CellTitle>{T("Coin")}</CellTitle>
                                <CellValue>
                                  {T(value.from_currency_code)}
                                </CellValue>
                              </Cell>
                              <Cell>
                                <CellTitle>{T("Amount")}</CellTitle>
                                <CellValue>
                                  {formatCurrency(
                                    value.amount,
                                    null,
                                    getCurrency()
                                  )}{" "}
                                  {value.from_currency_code}
                                </CellValue>
                              </Cell>
                            </>
                          ) : (
                            <>
                              <Cell>
                                <CellTitle>{T("From Currency")}</CellTitle>
                                <CellValue>
                                  {T(value.from_currency_code)}
                                </CellValue>
                              </Cell>
                              <MobileContainer>
                                <Cell>
                                  <CellTitle>{T("To Currency")}</CellTitle>
                                  <CellValue>
                                    {value?.dest_currency_code}
                                  </CellValue>
                                </Cell>
                              </MobileContainer>

                              <Cell>
                                <CellTitle>{T("From Amount")}</CellTitle>
                                <CellValue>
                                  {formatCurrency(
                                    value.amount,
                                    null,
                                    getCurrency()
                                  )}{" "}
                                  {value.from_currency_code}
                                </CellValue>
                              </Cell>

                              <MobileContainer>
                                <Cell>
                                  <CellTitle>{T("To Amount")}</CellTitle>
                                  <CellValue>
                                    <BTCValue>
                                      {formatCurrency(
                                        value?.toAmount ?? "0",
                                        null,
                                        getCurrency()
                                      )}{" "}
                                      {value?.dest_currency_code}
                                    </BTCValue>
                                  </CellValue>
                                </Cell>
                              </MobileContainer>
                              <DesktopContainer>
                                <Cell style={{ borderBottom: "none" }}>
                                  <CellTitle>{T("Transaction Fee")}</CellTitle>
                                  <CellValue>
                                    {formatCurrency(
                                      value?.fee_amount ?? 0,
                                      null,
                                      getCurrency()
                                    )}{" "}
                                    {value.from_currency_code}
                                  </CellValue>
                                </Cell>
                              </DesktopContainer>
                              <MobileContainer>
                                <Cell>
                                  <CellTitle>{T("Transaction Fee")}</CellTitle>
                                  <CellValue>
                                    {formatCurrency(
                                      value?.fee_amount ?? 0,
                                      null,
                                      getCurrency()
                                    )}{" "}
                                    {value.from_currency_code}
                                  </CellValue>
                                </Cell>
                              </MobileContainer>

                              <MobileContainer>
                                <Cell>
                                  <CellTitle>{T("Avatar ID")}</CellTitle>
                                  <CellValue>{value.item_id}</CellValue>
                                </Cell>
                              </MobileContainer>
                            </>
                          )}
                        </>
                      )}
                    </Row>
                    <Row className="lg:w-[399px]">
                      {type === "crypto" ? (
                        <DesktopContainer>
                          <Cell>
                            <CellTitle>{T("Transaction ID")}</CellTitle>
                            <CellValue className="transactionId">
                              <Copy
                                splitFont={25}
                                splitEnd={0}
                                numDot={3}
                                text={value?.code}
                              />
                            </CellValue>
                          </Cell>
                        </DesktopContainer>
                      ) : (
                        <DesktopContainer>
                          <Cell>
                            <CellTitle>{T("Time")}</CellTitle>
                            <CellValue>{value.time}</CellValue>
                          </Cell>
                        </DesktopContainer>
                      )}

                      {type === "crypto" ? (
                        <>
                          <DesktopContainer>
                            <>
                              <Cell>
                                <CellTitle>{T("From Address")}</CellTitle>
                                {value?.from_wallet_address ? (
                                  <CellValue>
                                    <Copy
                                      splitFontLg={32}
                                      splitFont={25}
                                      splitEnd={0}
                                      numDot={3}
                                      text={value?.from_wallet_address}
                                    />
                                  </CellValue>
                                ) : null}
                              </Cell>
                              <Cell>
                                <CellTitle>{T("To Address")}</CellTitle>
                                <CellValue>
                                  {value?.dest_wallet_address ? (
                                    <Copy
                                      splitFontLg={32}
                                      splitFont={25}
                                      splitEnd={0}
                                      numDot={3}
                                      text={value?.dest_wallet_address}
                                    />
                                  ) : null}
                                </CellValue>
                              </Cell>
                              <Cell>
                                <CellTitle>
                                  {value.dest_currency_code} {T("Value")}
                                </CellTitle>
                                {value.typeCode == 5 && type === "crypto" ? (
                                  <CellValue>
                                    <BTCValue>
                                      {value?.toAmount} {"ETH"}
                                    </BTCValue>
                                    <LocalValue>
                                      <div className="mr-1">
                                        <EqualIcon style={{ width: "12px" }} />
                                      </div>{" "}
                                      {formatLocalCurrency(value.local)}
                                    </LocalValue>
                                  </CellValue>
                                ) : (
                                  <CellValue>
                                    <BTCValue>
                                      {value?.coinValue}{" "}
                                      {value.dest_currency_code ||
                                        value.from_currency_code}
                                    </BTCValue>
                                    <LocalValue>
                                      <div className="mr-1">
                                        <EqualIcon style={{ width: "12px" }} />
                                      </div>{" "}
                                      {formatLocalCurrency(value.local)}
                                    </LocalValue>
                                  </CellValue>
                                )}
                              </Cell>
                            </>
                          </DesktopContainer>
                        </>
                      ) : (
                        <>
                          {value?.from_currency_code
                            ?.toString()
                            ?.toLowerCase() === "sotd" ? (
                            <>
                              <Cell>
                                <CellTitle>{T("To Address")}</CellTitle>
                                <CellValue>
                                  <Copy text={value?.dest_wallet_address} />
                                </CellValue>
                              </Cell>
                            </>
                          ) : (
                            <DesktopContainer>
                              <>
                                <Cell>
                                  <CellTitle>{T("To Currency")}</CellTitle>
                                  <CellValue>
                                    {value?.dest_currency_code}
                                  </CellValue>
                                </Cell>
                                <Cell>
                                  <CellTitle>{T("To Amount")}</CellTitle>
                                  <CellValue>
                                    <BTCValue>
                                      {formatCurrency(
                                        value?.toAmount ?? "0",
                                        null,
                                        getCurrency()
                                      )}{" "}
                                      {value?.dest_currency_code}
                                    </BTCValue>
                                  </CellValue>
                                </Cell>
                                <Cell>
                                  <CellTitle>{T("Avatar ID")}</CellTitle>
                                  <CellValue>{value.item_id}</CellValue>
                                </Cell>
                              </>
                            </DesktopContainer>
                          )}
                        </>
                      )}
                      {type === "crypto" && (
                        <Cell>
                          <CellTitle>{T("Transfer Amount")}</CellTitle>
                          {value?.typeCode === 2 && (
                            <CellValue>
                              {formatCurrency(
                                value.final_amount,
                                null,
                                getCurrency()
                              )}{" "}
                              {value.dest_currency_code ||
                                value.from_currency_code}
                            </CellValue>
                          )}
                        </Cell>
                      )}

                      <Cell style={{ borderBottom: "none" }}>
                        <CellTitle>{T("Status")}</CellTitle>
                        <CellValue>
                          <b>{T(value.status)}</b>
                        </CellValue>
                      </Cell>
                    </Row>
                  </Body>
                  {value.statusCode === 4 ? (
                    <div
                      className="pb-[52px] mb-[48px]"
                      style={{ borderBottom: "0.5px solid #cccccc" }}
                    >
                      <Cell className={"reject_reason"}>
                        <CellTitle style={{ color: "#000", fontWeight: 600 }}>
                          {T("Reject Reason")}
                        </CellTitle>
                        <CellValue style={{ height: "auto", minHeight: 26 }}>
                          <div style={{ marginTop: 4 }}>
                            {(value?.approval_histories || []).map(
                              (item, index) => {
                                return (
                                  <div
                                    style={{ fontSize: 14, display: "flex" }}
                                    key={index.toString()}
                                  >
                                    <span
                                      style={{
                                        fontWeight: "500",
                                        marginRight: 6,
                                      }}
                                    >
                                      {item?.email ? item?.email + ":" : ""}
                                    </span>
                                    <span>{item?.reject_reason || ""}</span>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </CellValue>
                      </Cell>
                    </div>
                  ) : null}
                </>
              ) : null}
              <Footer className="pb-2">
                <FormButton style={{ maxWidth: 300 }} onClick={onClose}>
                  {T("Back")}
                </FormButton>
              </Footer>
            </>
          ) : null}
          {mode === "cancel" ? (
            <ModalCancel
              onClose={(event) => {
                if (event) {
                  onClose(event);
                } else {
                  setSearchParams(
                    (prev) => {
                      const params = new URLSearchParams(prev);
                      params.set("mode", "detail");
                      return params;
                    },
                    {
                      replace: true,
                    }
                  );
                }
              }}
              value={row}
            />
          ) : null}
        </ContentWaper>
      </ModalContainer>
    </Modal>
  );
}

export default React.memo(Detail, () => false);
